/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SignatureField from "./components/SignatureField.vue";
import TripDetail from "./components/TripDetail.vue";
import StopList from "./components/StopList.vue";
import StopDetail from "./components/StopDetail.vue";

const __vue_script__ = {
  name: "Home",
  components: { SignatureField, TripDetail, StopList, StopDetail },
  props: ["doc", "reasons"],
  data: () => {
    return { stop: null };
  },
  created() {},
  mounted() {},
  computed: {
    editable() {
      return this.doc.status === "Planned" || this.doc.status === "In Transit";
    },
  },
  methods: {
    onStopSelected(stop) {
      this.stop = stop;
    },
    onBack() {
      this.stop = null;
    },
    onSave() {
      // save to db
      // update cached doc
      this.stop = null;
    },
  },
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.doc
    ? _c("div", { staticClass: "trip-container mx-auto" }, [
        _c("h4", { staticClass: "text-center" }, [_vm._v("Delivery Trip")]),
        _vm._v(" "),
        _c("h3", { staticClass: "text-center mt-3" }, [
          _vm._v(_vm._s(_vm.doc.name))
        ]),
        _vm._v(" "),
        !_vm.editable
          ? _c(
              "div",
              { staticClass: "alert alert-info", attrs: { role: "alert" } },
              [
                _vm._v("\n    Trip is "),
                _c("strong", [_vm._v("completed")]),
                _vm._v(" or "),
                _c("strong", [_vm._v("cancelled")]),
                _vm._v(" and is\n    not editable.\n  ")
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.stop
          ? _c(
              "div",
              [
                _c("stop-detail", {
                  attrs: { stop: _vm.stop, reasons: _vm.reasons },
                  on: { back: _vm.onBack, save: _vm.onSave }
                })
              ],
              1
            )
          : _c(
              "div",
              [
                _c("trip-detail", {
                  staticClass: "mb-3",
                  attrs: { doc: _vm.doc }
                }),
                _vm._v(" "),
                _c("h5", { staticClass: "mt-3" }, [_vm._v("Stops")]),
                _vm._v(" "),
                _c("stop-list", {
                  attrs: { stops: _vm.doc.stops, editable: _vm.editable },
                  on: { selected: _vm.onStopSelected }
                })
              ],
              1
            )
      ])
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-456cbb29_0", { source: "\n.trip-container[data-v-456cbb29] {\n  max-width: 576px;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n", map: {"version":3,"sources":["../mesrajaya/mesrajaya/public/js/delivery_trip_web/Home.vue"],"names":[],"mappings":";AAmEA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AACA","file":"Home.vue","sourcesContent":["<template>\n  <div class=\"trip-container mx-auto\" v-if=\"doc\">\n    <h4 class=\"text-center\">Delivery Trip</h4>\n    <h3 class=\"text-center mt-3\">{{ doc.name }}</h3>\n\n    <div v-if=\"!editable\" class=\"alert alert-info\" role=\"alert\">\n      Trip is <strong>completed</strong> or <strong>cancelled</strong> and is\n      not editable.\n    </div>\n\n    <div v-if=\"stop\">\n      <stop-detail\n        :stop=\"stop\"\n        :reasons=\"reasons\"\n        @back=\"onBack\"\n        @save=\"onSave\"\n      />\n    </div>\n    <div v-else>\n      <trip-detail :doc=\"doc\" class=\"mb-3\" />\n      <h5 class=\"mt-3\">Stops</h5>\n      <stop-list\n        :stops=\"doc.stops\"\n        :editable=\"editable\"\n        @selected=\"onStopSelected\"\n      />\n    </div>\n  </div>\n</template>\n\n<script>\nimport SignatureField from \"./components/SignatureField.vue\";\nimport TripDetail from \"./components/TripDetail.vue\";\nimport StopList from \"./components/StopList.vue\";\nimport StopDetail from \"./components/StopDetail.vue\";\n\nexport default {\n  name: \"Home\",\n  components: { SignatureField, TripDetail, StopList, StopDetail },\n  props: [\"doc\", \"reasons\"],\n  data: () => {\n    return { stop: null };\n  },\n  created() {},\n  mounted() {},\n  computed: {\n    editable() {\n      return this.doc.status === \"Planned\" || this.doc.status === \"In Transit\";\n    },\n  },\n  methods: {\n    onStopSelected(stop) {\n      this.stop = stop;\n    },\n    onBack() {\n      this.stop = null;\n    },\n    onSave() {\n      // save to db\n      // update cached doc\n      this.stop = null;\n    },\n  },\n};\n</script>\n\n<style scoped>\n.trip-container {\n  max-width: 576px;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-456cbb29"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../mesrajaya/mesrajaya/public/js/delivery_trip_web/Home.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__